const logicApparelHatDetails = {
  "logic-lc-logo-new-era-9fifty-flat-bill-snapback-shipping-included": {
    "style": "Flat bill",
    "fit": "Snapback",
    "brand": "New Era"
  },
  "logic-curved-bill-mesh-trucker-2-tone-charcoal-white-snapback": {
    "style": "Trucker",
    "fit": "Snapback",
    "brand": "Richardson"
  },
  "logic-lc-logo-new-era-9fifty-camo-flat-bill-snapback-cap-shipping-included": {
    "style": "Flat bill",
    "fit": "Snapback",
    "brand": "New Era"
  },
  "logic-upside-down-curved-bill-richardson-258-5-panel-rope-cap-snapback-shipping-included": {
    "style": "Rope",
    "fit": "Snapback",
    "brand": "Richardson"
  },
  "logic-3d-silicone-logo-bucket-hat-shipping-included": {
    "style": "Bucket",
    "fit": "One size"
  },
  "logic-baseball-embroidery-logo-hat-richardson-pts30-lite-r-flex-shipping-included": {
    "style": "Fitted",
    "fit": "Stretch fit",
    "brand": "Richardson"
  },
  "logic-flat-bill-hat-camo-w-black-bill-snapback-copy": {
    "style": "Flat bill",
    "fit": "Snapback",
    "brand": "YP Classics"
  },
  "logic-embroidery-hat-flexfit-110-snapback-shipping-included": {
    "style": "Flat bill",
    "fit": "Snapback",
    "brand": "Flexfit"
  },
  "cursive-logic-5-panel-corduroy-trucker-hat-snapback-cap-shipping-included": {
    "style": "Trucker",
    "fit": "Snapback"
  },
  "logic-fitted-6-panel-hat-3-sizes-multiple-colors": {
    "style": "Fitted",
    "fit": "Stretch fit",
    "brand": "Yupoong"
  },
  "logic-patterned-trucker-hats-richardson": {
    "style": "Trucker",
    "fit": "Snapback",
    "brand": "Richardson"
  },
  "logic-performance-embroidery-visor": {
    "style": "Visor",
    "fit": "Adjustable",
    "brand": "Flexfit"
  },
  "logic-script-logo-foam-hat-mesh-snapback-shipping-included": {
    "style": "Trucker",
    "fit": "Snapback"
  }
};
const logicApparelFixedColors = {
  "blackout-logic-jersey-custom-name-ships-in-3-4-weeks": ["Black", "Gray"],
  "logic-lc-black-white-jersey-custom-name-shipping-incl-ships-in-3-4-weeks": [
    "Black",
    "White"
  ],
  "logic-modern-light-blue-white-jersey-shipping-included": [
    "Blue",
    "White"
  ],
  "logic-marble-jersey-design-ships-in-3-weeks": [
    "Black",
    "White"
  ],
  "throw-logic-stripped-short-sleeve-hoodie-full-sublimation": [
    "Blue",
    "Gray"
  ]
};
const logicApparelCategories = ['apparel', 'hats', 'shirts', 'hoodies', 'jerseys', 'shorts', 'joggers'];
const logicApparelSources = [...logicApparelCategories];
const logicApparelSorts = ['featured', 'newest', 'price-low', 'price-high', 'title'];
const logicApparelNormalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
const logicApparelSize = value => {
  const text = String(value || '').trim();
  const sizes = {'extra small':'XS', 'x-small':'XS', 'small':'S', 'medium':'M', 'large':'L', 'extra large':'XL', 'x-large':'XL', 'xxl':'2XL', 'xxxl':'3XL', 'xxxxl':'4XL', 'one size':'One size', 'osfm':'One size', 'osfa':'One size'};
  return sizes[logicApparelNormalize(text)] || text;
};
const logicApparelColors = value => {
  const text = logicApparelNormalize(value);
  if (!text || text === 'default title') return [];
  const families = [
    ['Black', /\bblack(?:out)?\b/], ['White', /\bwhite\b/], ['Gray', /\b(gray|grey|charcoal|silver|graphite|gry|htdchar|lthtgry)\b/],
    ['Blue', /\b(blue|navy|royal|cobalt)\b/], ['Red', /\b(red|maroon|burgundy|cardinal)\b/], ['Green', /\b(green|olive|sage|loden|spruce|forest)\b/],
    ['Pink', /\b(pink|fuchsia|magenta)\b/], ['Purple', /\b(purple|violet|lavender)\b/], ['Orange', /\borange\b/], ['Yellow', /\b(yellow|gold)\b/],
    ['Teal', /\b(teal|turquoise|aqua)\b/], ['Tan', /\b(tan|khaki|beige|cream|sand)\b/], ['Brown', /\b(brown|chocolate)\b/]
  ];
  if (text === 'heathered steel') return ['Gray'];
  const matches = families.filter(([, pattern]) => pattern.test(text)).map(([label]) => label);
  return matches.length ? matches : [String(value).trim()];
};
const logicApparelDefaultState = (category = 'apparel') => ({category: logicApparelCategories.includes(category) ? category : 'apparel', q: '', style: '', brand: '', fit: '', color: '', size: '', cut: '', stock: true, sort: 'featured'});
const logicApparelPrepare = product => {
  const names = (product.options || []).map(logicApparelNormalize);
  const index = key => names.findIndex(name => key.includes(name));
  const colorIndex = index(['color', 'colour']);
  const sizeIndex = index(['size']);
  const cutIndex = index(['cut', 'fit']);
  const variants = (product.variants || []).map(raw => {
    const variant = Array.isArray(raw) ? {id:raw[0], available:raw[1], price:raw[2], options:raw[3], image:product.images?.[raw[4]] || null} : raw;
    return {...variant, colors: colorIndex < 0 ? (logicApparelFixedColors[product.handle] || []) : logicApparelColors(variant.options[colorIndex]), size: sizeIndex < 0 ? '' : logicApparelSize(variant.options[sizeIndex]), cut: cutIndex < 0 ? '' : String(variant.options[cutIndex] || '').trim()};
  });
  const hat = logicApparelHatDetails[product.handle] || {};
  const searchText = logicApparelNormalize([product.title, product.type, ...(product.tags || []), ...Object.values(hat), ...variants.flatMap(v => [...(v.options || []), ...v.colors])].join(' '));
  return {...product, hat, variants, searchText};
};
const logicApparelVariantMatches = (variant, state, except = '') => {
  if (state.stock && !variant.available) return false;
  if (except !== 'color' && state.color && !variant.colors.includes(state.color)) return false;
  if (except !== 'size' && state.size && variant.size !== state.size) return false;
  if (except !== 'cut' && state.cut && variant.cut !== state.cut) return false;
  return true;
};
const logicApparelProductMatches = (product, state, except = '') => {
  if (state.category !== 'apparel' && !product.categories.includes(state.category)) return false;
  if (state.q && !product.searchText.includes(logicApparelNormalize(state.q))) return false;
  for (const key of ['style', 'brand', 'fit']) if (key !== except && state[key] && product.hat[key] !== state[key]) return false;
  return product.variants.some(variant => logicApparelVariantMatches(variant, state, except));
};
const logicApparelInlineSources = payload => {
  if (!payload || payload.version !== 2 || !Array.isArray(payload.products) || !Array.isArray(payload.sources) || payload.sources.length !== logicApparelSources.length) return null;
  const products = new Map(payload.products.map(product => [String(product.id),product]));
  const categories = new Set();
  const sources = [];
  for (const source of payload.sources) {
    if (!logicApparelSources.includes(source.category) || categories.has(source.category) || !Array.isArray(source.ids) || source.page !== 1) return null;
    categories.add(source.category);
    if (source.ids.some(id => !products.has(String(id)))) return null;
    sources.push({category:source.category, products:source.ids.map(id => products.get(String(id))), next:source.next});
  }
  return sources;
};
const logicApparelResolveSources = async (inline, readCollection) => {
  if (!inline) return Promise.all(logicApparelSources.map(category => readCollection(category)));
  return Promise.all(inline.map(async source => {
    if (!source.next) return source;
    const remaining = await readCollection(source.category,source.next);
    return {...source, products:[...source.products,...remaining.products], next:null};
  }));
};
class LogicApparelFinder extends (globalThis.HTMLElement || class {}) {
  async connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.startedAt = performance.now();
    this.dataset.ready = 'false';
    this.dataset.requestCount = '0';
    this.text = JSON.parse(this.querySelector('[data-translations]').textContent);
    this.products = [];
    this.limit = 24;
    this.abort = new AbortController();
    this.readURL();
    this.bindEvents();
    this.updateRail();
    await this.load();
  }
  disconnectedCallback() {
    this.abort?.abort();
    clearTimeout(this.searchTimer);
    this.started = false;
  }
  readURL() {
    const url = new URL(location.href);
    const category = url.pathname.split('/').filter(Boolean).pop();
    this.state = logicApparelDefaultState(logicApparelCategories.includes(category) ? category : this.dataset.category);
    for (const key of ['q','style','brand','fit','color','size','cut']) this.state[key] = (url.searchParams.get('apparel_' + key) || '').slice(0,150);
    this.state.stock = url.searchParams.get('apparel_stock') !== '0';
    const sort = url.searchParams.get('apparel_sort');
    if (logicApparelSorts.includes(sort)) this.state.sort = sort;
  }
  writeURL(replace = false) {
    const url = new URL(location.href);
    url.pathname = this.dataset.collectionsUrl.replace(/\/$/,'') + '/' + this.state.category;
    url.searchParams.delete('page');
    url.searchParams.delete('sort_by');
    for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') || key.startsWith('apparel_')) url.searchParams.delete(key);
    for (const key of ['q','style','brand','fit','color','size','cut']) if (this.state[key]) url.searchParams.set('apparel_' + key, this.state[key]);
    if (!this.state.stock) url.searchParams.set('apparel_stock','0');
    if (this.state.sort !== 'featured') url.searchParams.set('apparel_sort',this.state.sort);
    if (url.href !== location.href) history[replace ? 'replaceState' : 'pushState']({},'',url);
  }
  async readCollection(category, signal, start) {
    let next = new URL(start || this.dataset.collectionsUrl + '/' + category, location.origin);
    next.pathname = this.dataset.collectionsUrl.replace(/\/$/,'') + '/' + category;
    next.searchParams.set('view','logic-apparel-data');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) next.searchParams.set('preview_theme_id',preview);
    const products = [], seen = new Set();
    while (next) {
      if (next.origin !== location.origin || seen.has(next.href)) throw new Error('Invalid collection pagination');
      seen.add(next.href);
      this.dataset.requestCount = String(Number(this.dataset.requestCount || 0) + 1);
      const response = await fetch(next.href, {credentials:'same-origin', cache:'no-store', signal});
      if (!response.ok) throw new Error('Collection request failed');
      const data = await response.json();
      if (!Array.isArray(data.products) || data.collection !== category) throw new Error('Invalid collection data');
      products.push(...data.products);
      if (data.next) {
        next = new URL(data.next,location.origin);
        next.searchParams.set('view','logic-apparel-data');
        if (preview) next.searchParams.set('preview_theme_id',preview);
      } else next = null;
    }
    return {category, products};
  }
  async load() {
    const status = this.querySelector('[data-status]');
    status.hidden = false;
    this.setAttribute('aria-busy','true');
    try {
      let inline = null;
      try { inline = logicApparelInlineSources(JSON.parse(this.querySelector('[data-initial-products]')?.textContent || 'null')); } catch {}
      if ([...new URL(location.href).searchParams.keys()].some(key => key.startsWith('filter.'))) inline = null;
      const sources = await logicApparelResolveSources(inline,(category,start) => this.readCollection(category,this.abort.signal,start));
      this.dataset.dataSource = inline ? (inline.some(source => source.next) ? 'inline-and-pages' : 'inline') : 'requests';
      const merged = new Map();
      for (const {category,products} of sources) for (const raw of products) {
        let product = merged.get(String(raw.id));
        if (!product) {
          product = logicApparelPrepare({...raw, categories:[], rank:merged.size});
          merged.set(String(raw.id),product);
        }
        if (category !== 'apparel' && !product.categories.includes(category)) product.categories.push(category);
      }
      for (const product of merged.values()) {
        const kinds = [product.type, ...(product.tags || [])].map(logicApparelNormalize);
        if (kinds.some(kind => ['hoodie','hoodies'].includes(kind)) && !product.categories.includes('hoodies')) product.categories.push('hoodies');
        if (kinds.some(kind => ['short','shorts'].includes(kind))) product.categories.push('shorts');
        if (kinds.some(kind => ['jogger','joggers','sweatpants'].includes(kind))) product.categories.push('joggers');
      }
      this.products = [...merged.values()];
      this.normalizeState();
      this.querySelector('[data-fallback]').hidden = true;
      this.querySelector('[data-results]').hidden = false;
      this.querySelectorAll('[data-enhanced]').forEach(el => { el.hidden = false; });
      status.hidden = true;
      this.render();
      this.writeURL(true);
      this.dataset.ready = 'true';
      this.dataset.readyAt = String(Math.round(performance.now()));
      this.dataset.readyMs = String(Math.round(performance.now() - this.startedAt));
      this.dataset.productCount = String(this.products.length);
      this.dataset.enhancementMs = String(Math.round(performance.now() - this.startedAt));
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = this.text.error + ' ';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'laf-retry';
      button.textContent = this.text.retry;
      button.addEventListener('click', () => { button.disabled = true; this.load(); }, {once:true});
      status.append(button);
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
  bindEvents() {
    const options = {signal:this.abort.signal};
    this.addEventListener('click',event => {
      const category = event.target.closest('[data-category-link]');
      if (category && this.products.length && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        this.state.category = category.dataset.categoryLink;
        this.state.style = ''; this.state.brand = ''; this.state.fit = '';
        this.normalizeState();
        this.change();
        return;
      }
      const style = event.target.closest('[data-style]');
      if (style) { this.state.style = style.dataset.style; this.change(); }
      if (event.target.closest('[data-reset]')) { this.state = logicApparelDefaultState(this.state.category); this.change(); }
      if (event.target.closest('[data-more]')) { this.limit += 24; this.renderResults(); }
      const rail = event.target.closest('[data-rail-direction]');
      if (rail) this.querySelector('[data-category-rail]').scrollBy({left: Number(rail.dataset.railDirection) * 220, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    },options);
    this.addEventListener('change',event => {
      const key = event.target.dataset.filter;
      if (key) { this.state[key] = key === 'stock' ? event.target.checked : event.target.value; this.change(); }
      if (event.target.matches('[data-sort]')) { this.state.sort = event.target.value; this.change(); }
    },options);
    this.querySelector('[data-search]').addEventListener('input',event => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => { this.state.q = event.target.value.trim(); this.change(true); },180);
    },options);
    window.addEventListener('popstate',() => { this.readURL(); this.normalizeState(); this.limit = 24; if (this.products.length) this.render(); },options);
    window.addEventListener('resize',() => this.updateRail(),options);
    this.querySelector('[data-category-rail]').addEventListener('scroll',() => this.updateRail(),options);
  }
  normalizeState() {
    if (!this.products.length) return;
    const group = this.products.filter(product => this.state.category === 'apparel' || product.categories.includes(this.state.category));
    for (const key of ['style','brand','fit']) if (this.state[key] && !group.some(product => product.hat[key] === this.state[key])) this.state[key] = '';
    for (const key of ['color','size','cut']) if (this.state[key] && !group.some(product => product.variants.some(variant => key === 'color' ? variant.colors.includes(this.state[key]) : variant[key] === this.state[key]))) this.state[key] = '';
  }
  change(replace = false) {
    this.limit = 24;
    this.writeURL(replace);
    this.render();
  }
  valuesFor(key) {
    const values = new Set();
    const base = this.products.filter(product => this.state.category === 'apparel' || product.categories.includes(this.state.category));
    for (const product of base) {
      if (['brand','fit','style'].includes(key)) { if (product.hat[key]) values.add(product.hat[key]); }
      else for (const variant of product.variants) {
        if (key === 'color') variant.colors.forEach(value => values.add(value));
        else if (variant[key]) values.add(variant[key]);
      }
    }
    const order = ['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
    return [...values].sort((a,b) => key === 'size' && order.includes(a) && order.includes(b) ? order.indexOf(a)-order.indexOf(b) : a.localeCompare(b,undefined,{numeric:true}));
  }
  facetAvailable(key,value) {
    return this.products.some(product => logicApparelProductMatches(product,{...this.state,[key]:value}));
  }
  renderFacets() {
    for (const key of ['brand','fit','color','size','cut']) {
      const wrap = this.querySelector('[data-facet-wrap="' + key + '"]');
      const select = wrap.querySelector('select');
      const values = this.valuesFor(key);
      const hatOnly = ['brand','fit'].includes(key);
      wrap.hidden = values.length < 2 || (hatOnly && !['hats','apparel'].includes(this.state.category));
      const plural = {brand:'brands',fit:'fits',color:'colors',size:'sizes',cut:'cuts'}[key];
      select.replaceChildren(new Option(this.text['all_' + plural],''));
      for (const value of values) {
        const option = new Option(value,value);
        option.disabled = !this.facetAvailable(key,value) && this.state[key] !== value;
        select.add(option);
      }
      select.value = this.state[key];
    }
    const focusedStyle = document.activeElement?.dataset?.style;
    const styles = this.valuesFor('style');
    const stylesWrap = this.querySelector('[data-hat-styles]');
    stylesWrap.hidden = this.state.category !== 'hats';
    const rail = this.querySelector('[data-style-rail]');
    const scroll = rail.scrollLeft;
    rail.replaceChildren();
    for (const value of ['',...styles]) {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.style = value;
      button.className = 'laf-style'; button.textContent = value || this.text.all_styles;
      button.setAttribute('aria-pressed',String(this.state.style === value));
      button.disabled = value !== this.state.style && !this.facetAvailable('style',value);
      rail.append(button);
    }
    rail.scrollLeft = scroll;
    if (focusedStyle !== undefined) [...rail.querySelectorAll('button')].find(button => button.dataset.style === focusedStyle)?.focus({preventScroll:true});
  }
  render() {
    this.querySelector('[data-heading]').textContent = this.text['category_' + this.state.category];
    this.querySelectorAll('[data-category-link]').forEach(link => {
      if (link.dataset.categoryLink === this.state.category) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });
    this.querySelector('[data-search]').value = this.state.q;
    this.querySelector('[data-filter="stock"]').checked = this.state.stock;
    this.querySelector('[data-sort]').value = this.state.sort;
    this.renderFacets();
    this.renderResults();
    this.updateRail();
  }
  renderResults() {
    const group = this.products.filter(product => this.state.category === 'apparel' || product.categories.includes(this.state.category));
    const matches = group.filter(product => logicApparelProductMatches(product,this.state)).map(product => ({product,variants:product.variants.filter(variant => logicApparelVariantMatches(variant,this.state))}));
    const minPrice = entry => Math.min(...entry.variants.map(variant => variant.price));
    matches.sort((a,b) => {
      if (this.state.sort === 'price-low') return minPrice(a)-minPrice(b);
      if (this.state.sort === 'price-high') return minPrice(b)-minPrice(a);
      if (this.state.sort === 'newest') return Number(b.product.created)-Number(a.product.created);
      if (this.state.sort === 'title') return a.product.title.localeCompare(b.product.title);
      return a.product.rank-b.product.rank;
    });
    const fragment = document.createDocumentFragment();
    for (const entry of matches.slice(0,this.limit)) fragment.append(this.card(entry));
    this.querySelector('[data-grid]').replaceChildren(fragment);
    this.querySelector('[data-count]').textContent = this.text.count.replace('__COUNT__',matches.length).replace('__TOTAL__',group.length);
    this.querySelector('[data-empty]').hidden = matches.length !== 0;
    this.querySelector('[data-more-wrap]').hidden = matches.length <= this.limit;
  }
  card({product,variants}) {
    const element = (tag,className,text) => { const node = document.createElement(tag); if(className) node.className = className; if(text) node.textContent = text; return node; };
    const li = element('li','laf-card');
    const link = element('a');
    const url = new URL(product.url,location.origin);
    const hasOptionFilter = !!(this.state.color || this.state.size || this.state.cut);
    const selected = variants.find(variant => variant.available) || variants[0];
    if (hasOptionFilter) url.searchParams.set('variant',selected.id);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    link.href = url.href;
    const media = element('div','laf-card-image');
    const imageURL = hasOptionFilter && selected.image ? selected.image : product.image;
    if (imageURL) { const image = element('img'); image.src = imageURL; image.alt = product.alt || product.title; image.loading = 'lazy'; image.width = 750; image.height = 750; media.append(image); }
    if (!variants.some(variant => variant.available)) media.append(element('span','laf-sold-out',this.text.sold_out));
    const copy = element('div','laf-card-copy');
    const title = product.title.replace(/\s*[-–]?\s*\*?shipping included.*$/i,'').replace(/\s*[-–]\s*ships in .*$/i,'').trim();
    copy.append(element('h2','',title));
    if (product.hat.style) copy.append(element('p','laf-card-detail',[product.hat.style, product.hat.fit].filter(Boolean).join(' · ')));
    const prices = variants.map(variant => variant.price);
    const low = Math.min(...prices), high = Math.max(...prices);
    const money = new Intl.NumberFormat(this.dataset.locale || 'en',{style:'currency',currency:this.dataset.currency || 'USD'}).format(low/100);
    copy.append(element('p','laf-price',(low !== high ? this.text.from + ' ' : '') + money));
    copy.append(element('span','laf-card-action',this.text.view_options + ' →'));
    link.append(media,copy); li.append(link);
    return li;
  }
  updateRail() {
    const rail = this.querySelector('[data-category-rail]');
    const arrows = this.querySelector('[data-rail-arrows]');
    arrows.hidden = rail.scrollWidth <= rail.clientWidth + 1;
    this.querySelector('[data-rail-direction="-1"]').disabled = rail.scrollLeft < 2;
    this.querySelector('[data-rail-direction="1"]').disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  }
}
if (typeof customElements !== 'undefined' && !customElements.get('logic-apparel-finder')) customElements.define('logic-apparel-finder',LogicApparelFinder);
if (typeof module !== 'undefined' && module.exports) module.exports = {logicApparelHatDetails,logicApparelFixedColors,logicApparelDefaultState,logicApparelPrepare,logicApparelColors,logicApparelSize,logicApparelProductMatches,logicApparelVariantMatches,logicApparelInlineSources,logicApparelResolveSources,LogicApparelFinder};
